<script>
import localSave  from './../../../utils/local-save'
import { trialDays } from './../../../configuration'

export default {
    name: 'PremiumWelcome',
    data() {
        return {
            trialDays,
        }
    },
    computed: {
        entitledFreeTrial() {
            return !this.$store.getters['premium/hasEverBeenPremium']
        },
    },
    methods: {
        skipPremiumOnboarding() {
            localSave.save('hasSkippedPremiumOnboarding', true)
            if (this.$router.history.current.path !== '/') {
                this.$router.back()
            } else {
                this.$router.push({ path: '/' })
            }
        },
    }
}
</script>

<template>
    <div :class="$style.welcome">
        <div :class="$style.welcomeBackground" />
        <BaseSection padded>
            <h1 :class="$style.mainHeader">Go Premium</h1>
            <div :class="$style.description">
                <p :class="$style.descriptionText">{{ entitledFreeTrial ? 'Unlock high-quality sound, zero ads and offline mixes - free for your first month.' : 'Unlock high-quality sound, zero ads and offline mixes.' }}</p>
                <ul :class="$style.salesPoints">
                    <li>High quality audio</li>
                    <li>No ads</li>
                    <li>Download mixes & listen offline anywhere on our mobile apps</li>
                    <li>VIP access: Skip the line and access new mixes before everyone else</li>
                </ul>
            </div>
            <div :class="$style.actionsContainer">
                <BaseLink
                    :class="$style.welcomeButton"
                    :to="$route.path + '/view-plans'"
                >
                    <BaseButton
                        button-type="highlight"
                        @click="() => {}"
                    > {{ entitledFreeTrial ? `Start ${trialDays}-Day Free Trial` : 'Upgrade Now' }} </BaseButton>
                </BaseLink>
                <span
                    :class="$style.escapeUrl"
                    @click="skipPremiumOnboarding"
                ><div>Maybe later - I like ads and low quality sound</div></span>
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.welcome {
    margin-top: $s-xs;
}

.welcomeBackground {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: url('/images/dj-vibing-purple-gradient.jpg');
    background-position: center;
    background-size: cover;
    opacity: 0.08;

    &.standalone {
        position: fixed;
    }
}

.mainHeader {
    @include h3;

    letter-spacing: -0.5px;
    margin-bottom: 0;  // Remove all bottom margin
}

.subtitle {
    @extend %h5;
}

.description {
    margin-top: 0;
}

.actionsContainer {
    position: relative;
    margin-top: $s-xxl;
}

.salesPoints {
    @extend %contentSubtitleL;

    padding: 0;
    margin-top: $s-xl;
    list-style: inside;
    text-align: left;
    font-size: 15px;
    line-height: 20px;
}

.escapeUrl {
    @extend %contentSubtitleM;

    text-align: center;
    text-decoration: underline;
    cursor: pointer;
}

.descriptionText {
    @extend %h6;
    font-weight: 400;
    color: $c-nevada-grey;
}

@include tablet {
    .actionsContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .escapeUrl {
        text-align: left;
    }
}

@include desktop {
    .welcome {
        margin-top: $s-h;
    }

    .mainHeader {
        @include h1;

        margin-bottom: $s-xxl;
    }

    .actionsContainer {
        margin-top: $s-h;
    }
}
</style>
